import React from "react";
import clsx from "clsx";

interface CheckboxProps {
  id?: string;
  variant?: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'dark';
  label?: string;
  name: string;
  checked: boolean;
  className?: string;
  disabled?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>, name: string) => void;
}

const Checkbox: React.FC<CheckboxProps> = ({
  id, variant, label, name, checked, className, disabled, onChange
}) => {
  return (
    <div className={clsx("form-check", `form-check-${variant || 'primary'}`, className)}>
      <input
        type="checkbox"
        id={id}
        name={name}
        checked={checked}
        disabled={disabled}
        className="form-check-input"
        onChange={(e) => onChange && onChange(e, name)}
      />
      {label && <label htmlFor={id} className="form-check-label">{label}</label>}
    </div>

  );
};

export default Checkbox;